import React, {useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import EditFormFooter from './EditFormFooter';
import WarningBox from './../messages/WarningBox';



const EditForm = ({children, title, onSubmitClick, onBackClick, onValidate}) => {  
    const [warningList, setWarningList] = useState([]);  

    const doSave = async () =>{ 
        setWarningList([]);       
        if (onValidate){
            let list = await onValidate();
            if (list && list.length > 0){
                setWarningList(list);
                return;
            }
        }     
        if (onSubmitClick){   
            onSubmitClick();   
        }     
    }   

    return (        
        <section className="section">
            <div className="limit padded">
                <div className="grid tight collapse480">
                    <div className="col s6of12">
                        <h1 className="text-red text-32">{title}</h1>                        
                    </div>
                </div>
                <div>    
                    <WarningBox list={warningList}>
                        {typeof children === 'function' ? (children()) : (children)}                        
                    </WarningBox>                    
                </div>              
                <EditFormFooter onSubmitClick={doSave} onBackClick={onBackClick}/>
            </div>
        </section>        
      );
};

EditForm.propTypes = {  
  newTitle : PropTypes.string,
  changeTitle : PropTypes.string,
  isNew : PropTypes.bool,  
  onSaveClick : PropTypes.func,
  onBackClick : PropTypes.func,
  onValidate : PropTypes.func
};

export default EditForm;